import React from 'react';
// @ts-expect-error checkout/react-components
import { LoadingElement } from '@checkout/react-components';
// @ts-expect-error type-lazyLoader
import { getLazyLoaderRenderFunction, lazyLoader } from '@/lib';

export const LazyFILimitExceededInterstitial = lazyLoader({
  loader: () => import('./FILimitExceededInterstitial'),
  loading: () => <LoadingElement />,
  name: 'fi_limit',
  render: getLazyLoaderRenderFunction({
    componentName: 'FILimitExceededInterstitial',
  }),
});
